<div class="row">
  @for (item of dataItems(); track item.label) {
    @if (item.alwaysDisplay || item.value) {
      <div class="col col-xs-12 col-md-3">
        <div class="activity-data-label">
          {{ item.label | translate }}
        </div>
        <div class="activity-data-value">
          @if (item.value) {
            <ng-container>
              @if (isDate(item.value)) {
                {{ item.value | date: dateFormat() }}
              } @else {
                {{ item.value }}
              }
            </ng-container>
          }
        </div>
      </div>
    }
  }
</div>
